import './assets/scss/light.scss';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {
  LicenseManager,
  ModuleRegistry,
  AllEnterpriseModule,
} from 'ag-grid-enterprise';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';

ModuleRegistry.registerModules([AllEnterpriseModule]);

const agGridLicenseKey =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-065592}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{S&P_Global_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Platts_Dimensions_Pro}_only_for_{20}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Platts_Dimensions_Pro}_need_to_be_licensed___{Platts_Dimensions_Pro}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_October_2025}____[v3]_[01]_MTc1OTc5MTYwMDAwMA==79669ccbba6a1477a38fa9bb64368381';
if (agGridLicenseKey) {
  LicenseManager.setLicenseKey(agGridLicenseKey);
}

// If a lazy-loaded chunk fails to load (e.g. it was removed by a new
// deployment while this tab still references the old build's hashed
// filename), force a one-time hard reload so the browser fetches the
// latest index.html and asset manifest instead of showing a broken page.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const reloadedKey = 'sfs-chunk-reload';
  if (!sessionStorage.getItem(reloadedKey)) {
    sessionStorage.setItem(reloadedKey, '1');
    window.location.reload();
  }
});

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const root = createRoot(rootElement);
root.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
);

registerServiceWorker();
